export enum AccessLevelEnum {
    ['View Only'] = 142,
    ['View And Edit'] = 143
  }

export enum TaxLevelEnum{
  Yes = 1,
  No = 0,
}
export enum DateLevelEnum{
  ['Single Day Event']=148,
  ['Multi Day Event']=149,
}

export const BooleanEnum = {
  ['Single Sign Up']: false,
  ['Multiple Shifts']: true,
};
export enum SortItemsEnum{
  ['High to Low'] = 0,
  ['Low to High'] = 1,
}
export enum ParticipantFormTypeEnum
{
    ['Standard Form'] = 161,
    ['Custom Form'] =162

}